module.exports = __webpack_public_path__ + "static/img/icon-whatsap.b6518855.svg";